var map = {
	"./bf-banner-bg.png": 9823,
	"./black-background.jpg": 4080,
	"./brands-icon-sprite.svg": 7411,
	"./cybermonday-banner-bg.jpg": 4554,
	"./cybermonday-bg.jpg": 1843,
	"./cybermonday-logo.png": 4515,
	"./cybermonday-pattern.jpg": 1370,
	"./electronics-icon.svg": 9928,
	"./fashion-icon.svg": 4587,
	"./feather-sprite.svg": 48,
	"./feature_img_1.jpg": 4662,
	"./feature_img_2.jpg": 2433,
	"./feature_img_3.jpg": 3908,
	"./feature_img_4.jpg": 5871,
	"./feature_img_5.jpg": 9522,
	"./heart-logo.png": 9370,
	"./hero.jpg": 9106,
	"./logo-qr-coupon--flat-2016.svg": 7778,
	"./logo-qr-coupon--simple-2019.svg": 336,
	"./sale-tag.svg": 2171,
	"./sale.png": 8939,
	"./savings_united_logo.png": 4901,
	"./shop-fallback.png": 4591,
	"./site-logo.png": 5475,
	"./sprite-two.png": 2232,
	"./teaser-label.png": 3647,
	"./xmas-bg.jpg": 679,
	"./xmas-boxes.png": 2843,
	"./xmas-sale-label.png": 94,
	"images/flat_2016/bf-banner-bg.png": 9823,
	"images/flat_2016/black-background.jpg": 4080,
	"images/flat_2016/brands-icon-sprite.svg": 7411,
	"images/flat_2016/cybermonday-banner-bg.jpg": 4554,
	"images/flat_2016/cybermonday-bg.jpg": 1843,
	"images/flat_2016/cybermonday-logo.png": 4515,
	"images/flat_2016/cybermonday-pattern.jpg": 1370,
	"images/flat_2016/electronics-icon.svg": 9928,
	"images/flat_2016/fashion-icon.svg": 4587,
	"images/flat_2016/feather-sprite.svg": 48,
	"images/flat_2016/feature_img_1.jpg": 4662,
	"images/flat_2016/feature_img_2.jpg": 2433,
	"images/flat_2016/feature_img_3.jpg": 3908,
	"images/flat_2016/feature_img_4.jpg": 5871,
	"images/flat_2016/feature_img_5.jpg": 9522,
	"images/flat_2016/heart-logo.png": 9370,
	"images/flat_2016/hero.jpg": 9106,
	"images/flat_2016/logo-qr-coupon--flat-2016.svg": 7778,
	"images/flat_2016/logo-qr-coupon--simple-2019.svg": 336,
	"images/flat_2016/sale-tag.svg": 2171,
	"images/flat_2016/sale.png": 8939,
	"images/flat_2016/savings_united_logo.png": 4901,
	"images/flat_2016/shop-fallback.png": 4591,
	"images/flat_2016/site-logo.png": 5475,
	"images/flat_2016/sprite-two.png": 2232,
	"images/flat_2016/teaser-label.png": 3647,
	"images/flat_2016/xmas-bg.jpg": 679,
	"images/flat_2016/xmas-boxes.png": 2843,
	"images/flat_2016/xmas-sale-label.png": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5766;